import { To } from "react-router";

export const parseRoutingPathname = (to: To | undefined): string => {
  if (typeof to === "string") {
    return to;
  }

  return to?.pathname ?? "/";
};
